import(/* webpackMode: "eager" */ "/workspace/app/(marketing)/m/page.tsx");
